const WAITLIST_URL = 'https://api-dev.proply.io/api/v1/auth/waitlist'

export type WaitlistPayload = {
  name: string
  email: string
}

export type WaitlistResult =
  | { ok: true }
  | { ok: false; message: string }

export async function submitWaitlist(payload: WaitlistPayload): Promise<WaitlistResult> {
  const name = payload.name.trim()
  const email = payload.email.trim()
  if (!name || !email) {
    return { ok: false, message: 'Please enter your name and email.' }
  }

  try {
    const res = await fetch(WAITLIST_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email }),
    })

    if (!res.ok) {
      const text = await res.text().catch(() => '')
      let message = text.trim() || `Something went wrong (${res.status}).`
      try {
        const data = JSON.parse(text) as { message?: string; error?: string }
        if (typeof data.message === 'string') message = data.message
        else if (typeof data.error === 'string') message = data.error
      } catch {
        /* keep message from body or default */
      }
      return { ok: false, message }
    }

    return { ok: true }
  } catch {
    return { ok: false, message: 'Network error. Please try again.' }
  }
}
